import React, { useState, useCallback } from "react";
import { IconButton, makeStyles, createStyles } from "@material-ui/core";
import {
  DatePicker as MuiDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";
import jaLocale from "date-fns/locale/ja";
import { format } from "date-fns";
import { getWarekiForYear } from "../../helper/JapanDate";
import CalendarIcon from "@material-ui/icons/Event";

// CSSスタイルを定義
const useStyles = makeStyles(() =>
  createStyles({
    picker: {
      display: "none",
    },
  })
);

export default function DatePicker(props) {
  const { value, onChange } = props;
  const classes = useStyles();

  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleOpenPicker = useCallback(() => {
    setIsPickerOpen(true);
  }, []);
  const handleClosePicker = useCallback(() => {
    setIsPickerOpen(false);
  }, []);

  class ExtendedUtils extends DateFnsUtils {
    getYearText(date) {
      let wareki = getWarekiForYear(date);
      return format(date, `${wareki}(yyyy)`, { locale: this.locale });
    }
  }

  const getMaxDate = useCallback(
    () => new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
    []
  );

  const getMinDate = useCallback(
    () => new Date(new Date().setFullYear(new Date().getFullYear() - 10)),
    []
  );

  return (
    <>
      <IconButton size="small" onClick={handleOpenPicker}>
        <CalendarIcon />
      </IconButton>

      <MuiPickersUtilsProvider utils={ExtendedUtils} locale={jaLocale}>
        <MuiDatePicker
          openTo="month"
          views={["year", "month"]}
          value={value}
          onChange={onChange}
          className={classes.picker}
          okLabel=""
          cancelLabel="キャンセル"
          open={isPickerOpen}
          onClose={handleClosePicker}
          maxDate={getMaxDate()}
          minDate={getMinDate()}
          autoOk={true}
        />
      </MuiPickersUtilsProvider>
    </>
  );
}
